import React, { Suspense } from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { MENU_PATHS } from './constants';
import { Spin } from 'antd';

const Attendance = React.lazy(() => import('./Main/screens/Attendance'));
const WorkingDay = React.lazy(() => import('./Main/screens/WorkingDay'));
const Holidays = React.lazy(() => import('./Main/screens/Holidays'));
const Modifications = React.lazy(() => import('./Main/screens/Modifications'));
const ActiveEnterprises = React.lazy(() => import('./Main/screens/ActiveEnterprises'));
const Incidents = React.lazy(() => import('./Main/screens/Incidents'));
const Hash = React.lazy(() => import('./Main/screens/Hash'));

export default function TimeTrackerRoutes() {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<Spin />}>
      <Switch>
        <Route path={`${path}/${MENU_PATHS.ATTENDANCE_REPORT}`} component={Attendance} />
        <Route path={`${path}/${MENU_PATHS.DAILY}`} component={WorkingDay} />
        <Route path={`${path}/${MENU_PATHS.HOLIDAYS}`} component={Holidays} />
        <Route path={`${path}/${MENU_PATHS.MODIFICATIONS}`} component={Modifications} />
        <Route
          path={`${path}/${MENU_PATHS.ACTIVE_ENTERPRISES}`}
          render={props => <ActiveEnterprises {...props} isActive={true} />}
        />
        <Route
          path={`${path}/${MENU_PATHS.INACTIVE_ENTERPRISES}`}
          render={props => <ActiveEnterprises {...props} isActive={false} />}
        />
        <Route path={`${path}/${MENU_PATHS.ISSUES}`} component={Incidents} />
        <Route path={`${path}/${MENU_PATHS.HASH}`} component={Hash} />
      </Switch>
    </Suspense>
  );
}
